export enum FilterType {
  String = 'string',
  Number = 'number',
  Boolean = 'boolean',
  Enum = 'enum',
  Date = 'date',
  DateTime = 'datetime',
  List = 'list',
  Source = 'source',
  JSON = 'json',
}
